import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";
import "./NadPlusCommon.css";

const NadPlusPage8: React.FC = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [otherText, setOtherText] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  useEffect(() => {
    const step7Completed = localStorage.getItem("completed-step-7");
    const step10Completed = localStorage.getItem("completed-step-10");
    if(isSermorelinPage){
      if (step10Completed) {
        navigate("/sermorelin/getting-started/step-11", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-10", { replace: true });
      }
    }else {
    if (step7Completed) {
      navigate("/nadplus/getting-started/step-8", { replace: true });
    } else {
      navigate("/nadplus/getting-started/step-7", { replace: true });
    }
  }
  }, []);

  const handleOptionClick = (option: string) => {
    if (option === "Other") {
      setSelectedOptions(["Other"]);
    } else {
      const newOptions = selectedOptions.includes(option)
        ? selectedOptions.filter((item) => item !== option)
        : [...selectedOptions.filter((item) => item !== "Other"), option];
      setSelectedOptions(newOptions);
      setOtherText(""); // clear input if "Other" is deselected
    }
  };

  const handleNext = () => {
    if (selectedOptions.length > 0) {
      const payload = {
        key: "primary_goal",
        value: selectedOptions,
        ...(selectedOptions.includes("Other") && otherText.trim() !== "" && {
          otherText: otherText.trim(),
        }),
      };

      localStorage.setItem("primary_goal", JSON.stringify(payload));
      if(isSermorelinPage){
        localStorage.setItem("completed-step-11", "true");
        navigate("/sermorelin/getting-started/step-12");
      }else{
        localStorage.setItem("completed-step-8", "true");
        navigate("/nadplus/getting-started/step-9");
      } 
    }
  };

  useEffect(() => {
    const savedPrimaryGoal = localStorage.getItem("primary_goal");
    if (savedPrimaryGoal) {
      try {
        const parsed = JSON.parse(savedPrimaryGoal);
        const value = parsed?.value;
        const normalizedValue = Array.isArray(value)
          ? value
          : typeof value === "string"
          ? [value]
          : [];
        setSelectedOptions(normalizedValue);
        if (parsed?.otherText) {
          setOtherText(parsed.otherText);
        }
      } catch (err) {
        console.error("Invalid localStorage data:", err);
        setSelectedOptions([]);
        setOtherText("");
      }
    }
  }, []);

  const options = [
    "Anti-aging and longevity",
    "Improve cognitive function (mood, mental clarity, focus, memory, and brain/nerve health)",
    "Cellular repair and DNA protection",
    "Increase energy",
    "Maintain a healthy weight or reduce body fat",
    "Improve athletic performance and recovery (boost stamina, improve muscle tone and recovery, and reduce exercise-induced fatigue)",
    "Immune system support",
    "Improve sleep duration and quality",
    "Support bone density and joint health",
    "Support during hormone replacement therapy",
    "Boost metabolism",
    "Other",
  ];

  const handleBack = () => {
    if(isSermorelinPage){
    navigate("/sermorelin/getting-started/step-10");
    }else{
    navigate("/nadplus/getting-started/step-7");
    }
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={ isSermorelinPage ? 75 : 72} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            What are your primary goals for seeking treatment?
          </p>
          <div className="signup-options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>

          {selectedOptions.includes("Other") && (
            <input
              type="text"
              placeholder="Please specify your goal"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              style={{
                width: "100%",
                marginTop: "16px",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontFamily: "inherit",
              }}
            />
          )}

          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={selectedOptions.length === 0}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage8;